module.exports = __webpack_public_path__ + "static/img/credit.c013459.png";